import axios, { AxiosRequestConfig } from 'axios';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { clearSessionCredentials, getSessionCredentials } from '../globalFunctions';

export const useReportOptions = (idReport: string) => {
    const token = getSessionCredentials()?.token ?? '';
    const navigate = useNavigate();

    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
        }
    };

    return useQuery({
        queryKey: ['reportOptions', idReport],
        queryFn: async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/report/options/${idReport}`,
                    requestConfig
                );

                return response.data;
            } catch (error: any) {
                const response = {
                    message: 'Erro ao carregar opções do relatório',
                    error: error
                };

                if ([401, 419].includes(error.response.status)) {
                    // Unauthorized
                    clearSessionCredentials(navigate);
                } else {
                    console.error(response);
                    return response;
                }
            }
        }
    });
};
